// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DfQRp5n11CYcsR5Pq_B5 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 420px;
  min-width: 420px;
  padding: 24px;
  border-radius: 24px;
}

.xjxhzDleEuyPMjy475hA {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  overflow-x: auto;
}

.ZisWX3mn50mg3kh6xK90 {
  height: 16px;
  width: 16px;
  padding: 4px;
  border-radius: 8px;
}

.eyyDbdjumB0UlmkqEfsg {
  height: 4px;
  width: 4px;
  background: var(--grey-color-60);
  border: 1px solid;
  border-radius: 2px;
}

.rbGKCYEqIqNqBDUcnc5R {
  background-color: var(--grey-color-200);
  border: 1px solid var(--grey-color-90);
}

.fj7WXQBlNgxFGTQ37ASn {
  background-color: var(--background-color);
  border: 1px solid var(--grey-color-300);
}
.fj7WXQBlNgxFGTQ37ASn .eyyDbdjumB0UlmkqEfsg {
  display: none;
}

.r_VLOKk7AO6RN9a9jDwS {
  font-family: var(--font-stack-full-heavy);
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
  line-height: 28px;
  color: var(--grey-color-90);
}

.TduCvFjIcqo_cMEqnMwj {
  font-family: var(--font-stack-full-book);
  font-size: 16px;
  font-style: normal;
  font-weight: 350;
  line-height: 24px;
  color: var(--grey-color-60);
}`, "",{"version":3,"sources":["webpack://./src/components/CardOptions/CardOptions.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,UAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,uCAAA;EACA,sCAAA;AACF;;AAEA;EACE,yCAAA;EACA,uCAAA;AACF;AACE;EACE,aAAA;AACJ;;AAGA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AAAF","sourcesContent":[".card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 420px;\n  min-width: 420px;\n  padding: 24px;\n  border-radius: 24px;\n}\n\n.cardOptions {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  overflow-x: auto;\n}\n\n.circle {\n  height: 16px;\n  width: 16px;\n  padding: 4px;\n  border-radius: 8px;\n}\n\n.dot {\n  height: 4px;\n  width: 4px;\n  background: var(--grey-color-60);\n  border: 1px solid;\n  border-radius: 2px;\n}\n\n.selected {\n  background-color: var(--grey-color-200);\n  border: 1px solid var(--grey-color-90);\n}\n\n.unselected {\n  background-color: var(--background-color);\n  border: 1px solid var(--grey-color-300);\n\n  & .dot {\n    display: none;\n  }\n}\n\n.cardTitle {\n  font-family: var(--font-stack-full-heavy);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 28px;\n  color: var(--grey-color-90);\n}\n\n.cardDescription {\n  font-family: var(--font-stack-full-book);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 350;\n  line-height: 24px;\n  color: var(--grey-color-60);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `DfQRp5n11CYcsR5Pq_B5`,
	"cardOptions": `xjxhzDleEuyPMjy475hA`,
	"circle": `ZisWX3mn50mg3kh6xK90`,
	"dot": `eyyDbdjumB0UlmkqEfsg`,
	"selected": `rbGKCYEqIqNqBDUcnc5R`,
	"unselected": `fj7WXQBlNgxFGTQ37ASn`,
	"cardTitle": `r_VLOKk7AO6RN9a9jDwS`,
	"cardDescription": `TduCvFjIcqo_cMEqnMwj`
};
export default ___CSS_LOADER_EXPORT___;
